import { render, staticRenderFns } from "./NotificationCodeView.vue?vue&type=template&id=b322ffaa&scoped=true&"
import script from "./NotificationCodeView.vue?vue&type=script&lang=js&"
export * from "./NotificationCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b322ffaa",
  null
  
)

export default component.exports